import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData, formatDateTimeToLocal } from '@devwareapps/devware-cap';
import { ConfigService } from '../../../../../environments/environment';
import { JobTimerQueryEntity } from '../../meta-data/extensions/job-timer-query-entity.model';
import { TimerEntity, TimersMetaDataItemNames } from '../../meta-data/timers-meta-data.service';
import { TimerCardBaseComponent } from '../base/timer-card-base.component';
import { TimerCardConfigComponent } from '../timer-card-config/timer-card-config.component';



@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Job Timer Card',
  key: 'jobTimerCard',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: TimersMetaDataItemNames.Timer,
  configComponent: TimerCardConfigComponent
})
@Component({
  selector: 'app-job-timer-card',
  templateUrl: './job-timer-card.component.html',
  styleUrls: ['./job-timer-card.component.scss', '../../styles/timer-cards.scss']
})
export class JobTimerCardComponent extends TimerCardBaseComponent {
  trustJobUrl: string;

  countUp(): boolean {
    return false;
  }

  getReferenceDate(timer: TimerEntity): string {
    return timer?.DueDateTime;
  }

  setupCardData(timer: TimerEntity) {
    const jobTimerEntity = this.data as JobTimerQueryEntity;

    this.titleDisplay = this.data.Ethos_JobIdDisplay || 'No Job Assigned';
    if (jobTimerEntity.EthosAddressCity && jobTimerEntity.EthosAddressStateProvinceIdDisplay) {
      this.titleTooltip = `${jobTimerEntity.EthosAddressCity}, ${jobTimerEntity.EthosAddressStateProvinceIdDisplay}`;
    }

    if (this.data.DueDateTime) {
      this.dateDisplay = `Due at ${formatDateTimeToLocal(this.data.DueDateTime, true, true)}`;
    }

    this.trustJobUrl = `${ConfigService.config.trustBaseUrl}/JobMgmt/ServiceManagement.aspx?JobId=${timer.Ethos_JobId}`;
  }

  timeLeftAdjustment() {
    return 1;
  }

  reset() {
    this.data.DueDateTime = this.timerUtilService.addDateTimeOffset(this.data.TimerMinutes);

    super.reset();
  }

}
